import React, { useState } from 'react'
import useApi from '../../hooks/useApi'
import { useParams, useNavigate } from "react-router-dom";
import { LoadingComponent } from 'usbc-web-react-library';
import LeagueSummary from '../LeagueSummary/LeagueSummary';
import LeagueRegistrationWizard from '../Wizard_V2/LeagueRegistrationWizard';
import ErrorLayout from '../Shared/ErrorLayout/ErrorLayout';
import { mainStepsIds } from '../Wizard_V2/WizardModel/constants';
import { subStepsIds } from '../Wizard_V2/WizardModel/constants';
import './LeagueRegister.css'

function LeagueRegister() {
    const [initialState, setInitialState] = useState(null);
    const [intialPosition, setIntialPosition] = useState(null);
    let navigate = useNavigate();


    const {
        fetchData: getRegisterationState,
        response: registerationState,
        loading: registerationStateLoading,
        error: registerationStateError
    } = useApi();

    let { lid, season } = useParams();

    const paymentStatus = new URLSearchParams(window.location.search).get(
        'payment'
    );
    const isConfirmPaymentMode = !!paymentStatus;

    React.useEffect(() => {

        getRegisterationState({ url: 'getregisterationstate/' + lid + '/' + season }).then(result => {
            if (isConfirmPaymentMode === false) {
                setInitialState({
                    applicantMemberId: result.memberId,
                    leagueName: result.leagueSummary.league.name,
                    leagueCategory: result.leagueSummary.league.category,
                    isLinked: result.isLinked,
                    isAgeValid: result.status !== 4,
                    isAlreadyRegistered: result.status === 3,
                    hasCurrentNationalLevelMembership: result.status === 1
                });
            } else {
                const paymentIntent = new URLSearchParams(window.location.search).get(
                    'payment_intent'
                );

                window.history.replaceState(
                    {},
                    document.title,
                    window.location.pathname
                )

                if (paymentStatus === '1') {
                    setIntialPosition({
                        ParentPosition: mainStepsIds.Finished,
                        SubStepPosition: subStepsIds.Finished
                    })
                    setInitialState({
                        paymentIntentId: paymentIntent,
                    });
                }
            }
        });
    }, []);

    function getContent() {
        if (isConfirmPaymentMode === false) {

            if (registerationState.isThereProfileError === true) {
                return <div className='custom-card mt-3' style={{ minHeight: '400px' }}>
                    <ErrorLayout title="An error occured"
                        subTitle="An error occured while reading your Community Profile." />
                </div>;
            } else if (registerationState.isProfileCompleted === false) {
                return <div className='custom-card mt-3' style={{ minHeight: '400px' }}>
                    <ErrorLayout title="Your Community Profile is incomplete."
                        subTitle="You must complete your profile and confirm your email address before you can continue to register for this league."
                        onClick={() => { window.open(registerationState.profileCompleteUrl, "_blank"); }}
                        buttonText="Update your Community Profile" />
                    <h5 className="text-center text-secondary">Return here and continue after you have completed your profile.</h5>
                    <div className="d-grid gap-2 col-1 mx-auto">
                        <button type="button" className="btn btn-primary bowl-btn" onClick={() => { navigate(0) }}>Register</button>
                    </div>
                </div>;
            } else {
                return initialState != null && <div className='mt-3'>
                    <LeagueRegistrationWizard initialState={initialState} intialPosition={intialPosition} />
                </div>
            }

        } else {
            return initialState != null && <div className='mt-3'>
                <LeagueRegistrationWizard initialState={initialState} intialPosition={intialPosition} />
            </div>
        }
    }


    return (
        <>
            <LoadingComponent isLoading={() => registerationStateLoading === true} description={'Let’s get ready to bowl…'}>
                {!!registerationState &&
                    <>
                        <LeagueSummary leagueSummary={registerationState.leagueSummary} />
                        {
                            getContent()
                        }
                    </>
                }
            </LoadingComponent>
        </>
    )
}

export default LeagueRegister